import { createStore } from "vuex";
import bootstrap from "bootstrap/dist/js/bootstrap.min.js";
import { auth } from "./auth.module.js";
import { profile } from "./profile.module.js";
import { role } from "./role.module.js";
import { user } from "./user.module.js";
import { category } from "./category.module.js";
import { tag } from "./tag.module.js";
import { item } from "./item.module.js";
import { statistics } from "./statistics.module.js";
import { proposal } from "./proposal.module.js";
import { agencies } from "./agencies.module.js";
import { agencyStyle } from "./agency.module.js"; // Import the agencyStyle module
import { notifications } from "./notifications.module.js"
import { modal } from "./modal.module.js";
import { agencyBilling } from "./agencyBilling.module.js";
import { useLoadingState } from './loadingState.module.js';

export default createStore({
  modules: {
    auth,
    profile,
    role,
    user,
    category,
    tag,
    item,
    statistics,
    proposal,
    agencies,
    agencyStyle,
    notifications,
    modal,
    agencyBilling,
  },
  state: {
    loadingState: useLoadingState(),
    hideConfigButton: false,
    isPinned: true,
    showConfig: false,
    isRTL: false,
    color: "",
    sidebarType: "bg-white",
    darkMode: false,
    isNavFixed: false,
    isAbsolute: false,
    showNavs: true,
    showSidenav: true,
    showNavbar: true,
    showFooter: true,
    showMain: true,
    layout: "default",
    bootstrap,
  },
  mutations: {
    toggleConfigurator(state) {
      state.showConfig = !state.showConfig;
    },
    navbarMinimize(state) {
      const sidenav_show = document.querySelector("#app");

      if (sidenav_show.classList.contains("g-sidenav-show") && sidenav_show.classList.contains("g-sidenav-hidden")) {
        sidenav_show.classList.add("g-sidenav-pinned");
        sidenav_show.classList.remove("g-sidenav-hidden");
        state.isPinned = true;
      } else if (sidenav_show.classList.contains("g-sidenav-show") && sidenav_show.classList.contains("g-sidenav-pinned")) {
        sidenav_show.classList.add("g-sidenav-hidden");
        sidenav_show.classList.remove("g-sidenav-pinned");
        state.isPinned = false;
      } else if (sidenav_show.classList.contains("g-sidenav-show")) {
        sidenav_show.classList.add("g-sidenav-pinned");
        state.isPinned = true;
      }
    },
    setSidebarType(state, payload) {
      state.sidebarType = payload;
    },
    navbarFixed(state) {
      if (state.isNavFixed === false) {
        state.isNavFixed = true;
      } else {
        state.isNavFixed = false;
      }
    },
    toggleDefaultLayout(state) {
      state.showNavbar = !state.showNavbar;
      state.showSidenav = !state.showSidenav;
      state.showFooter = !state.showFooter;
    },
  },
  actions: {
    toggleSidebarColor({ commit }, payload) {
      commit("setSidebarType", payload);
    },
  },
  getters: {},
});
